"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { MapPin, Car } from "lucide-react";
export default function VenueDetails() {
  const {
    ref: mapRef,
    isVisible: mapVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: planRef,
    isVisible: planVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="venue-details" className="py-16 px-6 !bg-[hsl(158,54%,18%)] md:py-24 md:px-12">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 md:gap-16">
          {}
          <div ref={mapRef} className={`flex flex-col gap-6 transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${mapVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
            <div className="overflow-hidden rounded-md bg-secondary">
              <img src="https://eilhconference.org/wp-content/uploads/2026/03/Enter-at-the-intersection-of-Santa-Rosa-and-Highland-Dr.png" alt="Venue Location Map" className="h-auto w-full object-cover transition-transform duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:scale-105" />
              <img src="https://eilhconference.org/wp-content/uploads/2026/03/C-7-parking.jpg" alt="Venue Location Map" className="h-auto w-full object-cover transition-transform duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:scale-105" />
            </div>

            <div className="flex flex-col gap-4 rounded-md border border-border bg-secondary p-6">
              <div className="flex items-start gap-3">
                <MapPin className="mt-1 h-5 w-5 flex-shrink-0 text-accent" />
                <div>
                  <h3 className="mb-1 font-display text-lg font-semibold text-foreground">
                    Location of Conference
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    1 Grand Ave
                    San Luis Obispo, CA 93407
                    United States<br />
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <Car className="mt-1 h-5 w-5 flex-shrink-0 text-accent" />
                <div>
                  <h3 className="mb-1 font-display text-lg font-semibold text-foreground">
                    Parking Information
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    C-7 parking lot. Parking is free for the duration of the conference.{" "}
                    <a href="https://maps.app.goo.gl/dNYDkgb5b8ELZHNt7" target="_blank" rel="noopener noreferrer" className="underline">
                      View on Google Maps
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {}
          <div ref={planRef} className={`flex flex-col gap-6 transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${planVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
            <div className="overflow-hidden rounded-md bg-secondary">
              <img src="https://superb-silkworm.10web.cloud/wp-content/uploads/2026/02/Pasted-Graphic-6.png" alt="Conference Floor Plan" className="h-auto w-full object-cover transition-transform duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:scale-105" />
            </div>

            <div className="rounded-md border border-border bg-secondary p-6">
              <h3 className="mb-3 font-display text-lg font-semibold text-foreground">
                Venue Layout
              </h3>
              <p className="text-sm text-muted-foreground">The conference space features multiple breakout rooms, a main auditorium, networking areas.</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}